<template>
	<p-card class="tw-flex tw-justify-between">
		<div class="tw--mt-4">
			<span class="text-info text-sm tw-text-left relative" style="bottom: -12px" >{{ selectedFactor.name }}</span>
			<factor-progress-bar
				:length="selectedFactor.weighWith.length"
				:completed-items-count="comparePivotIndex + 1"
				complete-position="right"
				class="tw-w-96"
			/>
		</div>
		<v-btn
			v-if="hasNextFactor"
			class="custom-button"
			color="primary"
			:disabled="!factorWeighingIsCompleted"
			@click="$emit('nextFactorClick')"
		>
			Siguiente Factor
		</v-btn>
		<div class="weighing-alert-message" v-if="!hasNextFactor">Terminaste presiona siguiente para ir al paso 3</div>
	</p-card>
</template>

<script>
import PCard from '@/modules/shared/components/ui/Card/p-card';
import WeighingFactorProgressBar
	from '@/modules/job-evaluation/components/supplies/valuation-model/valuation-model/commons/WeighingFactorProgressBar';
import FactorProgressBar
	from '@/modules/job-evaluation/components/supplies/valuation-model/valuation-model/commons/FactorProgressBar';

export default {
	name: 'WeighingFactorStatus',
	components: { FactorProgressBar, WeighingFactorProgressBar, PCard },
	props: ['selectedFactor', 'selectedFactors', 'hasNextFactor', 'combinations', 'factorWeighingIsCompleted', 'comparePivotIndex'],
};
</script>

<style lang="scss" scoped>
.weighing-alert-message {
	border: solid 1px #f09c2b;
	background-color: rgba(240, 156, 43, 0.09);
	color: var(--app-color-secondary);
	padding: 5px 15px;
	border-radius: 20px;
	display: inline-flex;
	align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/components/supplies/valuation-model/valuation-model/factors-weighting/WeighingFactorStatus.vue